module.exports = __webpack_public_path__ + "static/media/dawghawtdawg-combined-1-iphonex.7b4cf856.png";